export default "/images/vendor/flag-icons/flags/1x1/lb.svg?887fc273b315b08dd141780f2ff96dd3";